module.exports = __webpack_public_path__ + "static/media/KN.3f457af0.svg";